/**
 * @generated SignedSource<<8517dac845d64d48d7b4730ed5988961>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerQueriesFontQuery$variables = Record<PropertyKey, never>;
export type composerQueriesFontQuery$data = {
  readonly fontFamilies: ReadonlyArray<{
    readonly fontFamilyID: number;
    readonly imageUrl: string;
    readonly name: string;
  }>;
};
export type composerQueriesFontQuery = {
  response: composerQueriesFontQuery$data;
  variables: composerQueriesFontQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontFamilyID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesFontQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FontFamily",
        "kind": "LinkedField",
        "name": "fontFamilies",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerQueriesFontQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FontFamily",
        "kind": "LinkedField",
        "name": "fontFamilies",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21e519685f13157f9b7ee31ce51687c2",
    "id": null,
    "metadata": {},
    "name": "composerQueriesFontQuery",
    "operationKind": "query",
    "text": "query composerQueriesFontQuery {\n  fontFamilies {\n    fontFamilyID\n    name\n    imageUrl\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "41f871f1368d92de7cec8eaef031465a";

export default node;
